import React from "react";
import { Card, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const StatsCardKanban = ({ label, value }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Card
      sx={{
        padding: "12px",
        borderRadius: "12px",
        border: `1px solid ${theme.palette.background.neutral}`,
        boxShadow: "none",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
      }}
    >
      <Typography sx={{ fontSize: isDesktop ? "12px !important" : "14px !important", color: theme.palette.secondary.black, opacity: 0.8, lineHeight: "14px" }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 800,
          color: theme.palette.secondary.black,
          fontSize: "20px !important",
          lineHeight: "28px",
        }}
      >
        {value}
      </Typography>
    </Card>
  );
};

export default StatsCardKanban;


